// src/components/AdminRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "@/context/useUser"; // Sesuaikan path context user Anda

interface AdminRouteProps {
    children?: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
    const { data: user, isLoading } = useUser();

    if (isLoading) {
        return <div>Loading...</div>; // Atau component spinner Anda
    }

    // Cek apakah user ada DAN memiliki role admin
    // Ganti `1` dengan ID role admin di database Anda (misal: "admin" atau 1)
    const isAdmin = user && user.role_id === 1;

    if (!isAdmin) {
        // Jika bukan admin, lempar kembali ke dashboard atau halaman 404
        return <Navigate to="/dashboard" replace />;
    }

    // Jika admin, render halaman tujuan
    return children ? <>{children}</> : <Outlet />;
}